/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Weclapp_Time_Filter_Days_SuffixInputs */



/**
* | output |
* | --- |
* | "days" |
*
* @param {Spaces_Weclapp_Time_Filter_Days_SuffixInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_weclapp_time_filter_days_suffix = /** @type {((inputs?: Spaces_Weclapp_Time_Filter_Days_SuffixInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Weclapp_Time_Filter_Days_SuffixInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Tage")
	return /** @type {LocalizedString} */ ("days")
});